import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	Typography
} from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from "@material-ui/core/Paper";
import {
	createStyles,
	makeStyles
} from "@material-ui/core/styles";
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import FastForwardIcon from '@material-ui/icons/FastForward';
import FastRewindIcon from '@material-ui/icons/FastRewind';

import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import PauseIcon from '@material-ui/icons/Pause';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import dayjs from 'dayjs';
import React, { useEffect, useState } from "react";
import { Rnd } from 'react-rnd';
import Tooltip from '@material-ui/core/Tooltip'
import SkipNextIcon from '@material-ui/icons/SkipNext';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useActions, useValues } from 'kea';


import { replaylogic, preferenceslogic } from 'src/store/global';
import vehiclelogic from 'src/store/vehicle';
import CSVDialog from 'src/utils/CSVDialog/CSVreplay';

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			minHeight: 0,
			flexGrow: 1,
			minWidth: 200
		},
		container: {
			maxHeight: 440,
		},
	}));


const useStyles2 = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	title: {
		flexGrow: 1,
		display: 'none',
		[theme.breakpoints.up('sm')]: {
			display: 'block',
		},
	},
}));



const columns = [
	{
		type: 'date',
		field: 'position_timestamp',
		headerName: 'Date & Time',
	},
	{
		io: true,
		field: 'ignition',
		headerName: 'Ignition',
	},
	{
		field: 'speed',
		headerName: 'Speed',
	},
	{
		field: 'address',
		headerName: 'Address',
	},
	{
		field: 'latitude',
		headerName: 'Latitude',
	},
	{
		field: 'longitude',
		headerName: 'Longitude',
	}
];


const ReplayPanel = () => {
	const classes = useStyles();
	const classes2 = useStyles2();

	const { vehicle, max, index } = useValues(replaylogic);
	const { setVehicle, setMax, setIndex } = useActions(replaylogic);
	const { setReplay: RemoveReplay } = useActions(vehiclelogic);
	const { vehicles } = useValues(vehiclelogic);

	const { replay } = useValues(preferenceslogic);
	const { setReplay } = useActions(preferenceslogic);

	let tracker_index = index;
	// let playInterval = null;
	const [playSeconds, setPlaySeconds] = useState(false);
	const [speed, setSpeed] = useState(0);


	const handleCloseClick = () => {
		setReplay({ ...replay, show: false });
		setVehicle(null);
		setIndex(0);
		setMax(0);
		RemoveReplay([])
	};

	useEffect(() => {
		let interval = null;
		if (playSeconds) {
			clearInterval(interval)
			interval = setInterval(handleNext, 750 / speed);
		}
		if (!playSeconds) clearInterval(interval);
		return () => clearInterval(interval);
	}, [playSeconds, speed]);// eslint-disable-line

	useEffect(() => {
		return () => {
			setReplay({ ...replay, show: false });
			setVehicle(null);
			setIndex(0);
			setMax(0);
		}
	}, [])// eslint-disable-line

	const handleBegin = () => {
		tracker_index = 0;
		setIndex(tracker_index)
		const pos = vehicle.status[tracker_index];
		if (pos) {
			global.gmap.panTo({
				lat: pos.latitude,
				lng: pos.longitude
			})
			// global.gmap.setZoom(15);
		}
	};

	const handleBefore = () => {
		tracker_index = tracker_index - 1;
		if (tracker_index < 0) {
			tracker_index = 0;
		}
		setIndex(tracker_index)
		const pos = vehicle.status[tracker_index];
		if (pos) {
			global.gmap.panTo({
				lat: pos.latitude,
				lng: pos.longitude
			})
			// global.gmap.setZoom(15);
		}
	};

	const handlePlay = () => {
		setSpeed(1);
		setPlaySeconds(true);
	};

	const handlePause = () => {
		setPlaySeconds(false);
	};

	const handleNext = () => {
		tracker_index = tracker_index + 1;
		if (tracker_index > max - 1) {
			tracker_index = max - 1;
		}
		setIndex(tracker_index)
		// console.log(replay_route_panel_tracker_max, replay_route_panel_tracker_index);
		const pos = vehicle.status[tracker_index];
		if (pos) {
			global.gmap.panTo({
				lat: pos.latitude,
				lng: pos.longitude
			})
			// global.gmap.setZoom(15);
		}
	};


	const handleEnd = () => {
		tracker_index = max - 1;
		setIndex(tracker_index)
		const pos = vehicle.status[tracker_index];
		if (pos) {
			global.gmap.panTo({
				lat: pos.latitude,
				lng: pos.longitude
			})
			// global.gmap.setZoom(15);
		}
	};


	return (
		<Rnd
			default={{
				x: 10,
				y: 240,
				width: 600,
			}}
			enableResizing={false}
			// disableDragging={true}
			bounds={"#panelHolder"}
			cancel={
				"#rnd-ignore-drag"
			}
		>
			<Paper className={classes.root} style={{ maxWidth: 600 }}>
				<div className={classes2.root}>
					<AppBar elevation={0} className="handle cursor" position="static">
						<Toolbar variant="dense">
							<Typography className={classes2.title} variant="h6" noWrap>
								Replay Route Panel
							</Typography>
							<div id={'rnd-ignore-drag'}>
								<Tooltip title='Close Replay'>
									<IconButton onClick={handleCloseClick} aria-label="less" className={classes.margin} >
										<CloseIcon htmlColor='white' />
									</IconButton>
								</Tooltip>
							</div>
						</Toolbar>
					</AppBar>
				</div>
				<TableContainer id={'rnd-ignore-drag'} className={classes.container} style={{ cursor: 'default' }}>
					<Table stickyHeader aria-label="sticky table" size={'small'}>
						<TableBody>
							<TableRow>
								<TableCell
									align={'left'}
									style={{
										minWidth: 100
									}}
								>
									<Typography>
										<b>{'D&T: '}</b><br />{dayjs(vehicle.status[tracker_index].position_timestamp).format('DD-MM-YYYY HH:mm:ss')}
									</Typography>
								</TableCell>
								<TableCell
									align={'left'}
									style={{
										minWidth: 100
									}}
								>
									<Typography>
										<b>{'Speed: '}</b><br />{vehicle.status[tracker_index].speed}
									</Typography>
									<Typography>
										<b>{'Signal: '}</b><br />{vehicle.status[tracker_index].signal}
									</Typography>
								</TableCell>
								<TableCell
									align={'left'}
									style={{
										minWidth: 100
									}}
								>
									<Typography>
										<b>{'Driving Kms: '}</b><br />{vehicle.total_distance / 1000}{' Kms'}
									</Typography>
									<Typography>
										<b>{'Towing Kms: '}</b><br />{vehicle.towing_distance / 1000}{' Kms'}
									</Typography>
								</TableCell>
								<TableCell
									align={'left'}
									style={{
										minWidth: 100
									}}
								>
									<Typography>
										<b>{'Fuel (L): '}</b><br />{vehicle.status[tracker_index].io.fuelL || '-'}
									</Typography>
									<Typography>
										<b>{'Fuel (%): '}</b><br />{vehicle.status[tracker_index].io.fuelP || '-'}
									</Typography>
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell
									align={'left'}
									style={{
										minWidth: 44
									}}
									colSpan={5}
								>
									<Typography>
										{vehicle.status[tracker_index].address}
									</Typography>
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell
									align={'center'}
									style={{
										minWidth: 44
									}}
									colSpan={5}
								>
									<Tooltip title='Start Position'>
										<IconButton disabled={playSeconds !== false || tracker_index === 0} id={'rnd-ignore-drag'} onClick={handleBegin} aria-label="less" className={classes.margin} >
											<SkipPreviousIcon />
										</IconButton>
									</Tooltip>
									{playSeconds ? <Tooltip title='Fast Forward -1x'>
										<IconButton id={'rnd-ignore-drag'} disabled={speed === 0.25} onClick={() => setSpeed((speed < 1 || speed - 1 < 1) ? speed / 2 : speed - 1)} aria-label="less" className={classes.margin} >
											<FastRewindIcon />
										</IconButton>
									</Tooltip> : <Tooltip title='Previous Position'>
										<IconButton disabled={playSeconds !== false || tracker_index === 0} id={'rnd-ignore-drag'} onClick={handleBefore} aria-label="less" className={classes.margin} >
											<NavigateBeforeIcon />
										</IconButton>
									</Tooltip>}
									<Tooltip title={playSeconds ? 'Play speed' : 'Play Route'}>
										<IconButton disabled={playSeconds !== false} id={'rnd-ignore-drag'} onClick={handlePlay} aria-label="less" className={classes.margin} >
											{playSeconds ? `${speed}x` : <PlayArrowIcon />}
										</IconButton>
									</Tooltip>
									<Tooltip title='Pause Route'>
										<IconButton disabled={playSeconds === false} id={'rnd-ignore-drag'} onClick={handlePause} aria-label="less" className={classes.margin} >
											<PauseIcon />
										</IconButton>
									</Tooltip>
									{playSeconds ?
										<Tooltip title='Fast Forward +1x'>
											<IconButton id={'rnd-ignore-drag'} disabled={speed === 5} onClick={() => setSpeed(speed < 1 ? speed * 2 : speed + 1)} aria-label="less" className={classes.margin} >
												<FastForwardIcon />
											</IconButton>
										</Tooltip>
										:
										<Tooltip title='Next Position'>
											<IconButton disabled={playSeconds !== false || tracker_index === max - 1} id={'rnd-ignore-drag'} onClick={handleNext} aria-label="less" className={classes.margin} >
												<NavigateNextIcon />
											</IconButton>
										</Tooltip>}
									<Tooltip title='Last Position'>
										<IconButton disabled={playSeconds !== false || tracker_index === max - 1} id={'rnd-ignore-drag'} onClick={handleEnd} aria-label="less" className={classes.margin} >
											<SkipNextIcon />
										</IconButton>
									</Tooltip>
									<CSVDialog rows={vehicle.status} columns={columns} filename={`${vehicles.find(v => v._id === vehicle._id).name} Replay`} />
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell
									align={'center'}
									style={{
										minWidth: 44
									}}
									colSpan={5}
								>
									<LinearProgress variant="determinate" value={(index / (max - 1)) * 100} />
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</TableContainer>
			</Paper>
		</Rnd>
	);
};

export default ReplayPanel;
